import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Reusable confirmation dialog
 */
const ConfirmDialog = ({ isOpen, title, message, confirmLabel = 'Delete', cancelLabel = 'Cancel', onConfirm, onCancel, destructive = true }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={onCancel} />
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4" onClick={onCancel}>
        <div
          className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start gap-3 mb-4">
            <div className={`p-2 rounded-full flex-shrink-0 ${destructive ? 'bg-red-100' : 'bg-amber-100'}`}>
              <AlertCircle className={`w-5 h-5 ${destructive ? 'text-red-600' : 'text-amber-600'}`} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-lg">{title}</h3>
              <p className="text-sm text-gray-500 mt-1">{message}</p>
            </div>
          </div>
          <div className="flex gap-3 mt-6">
            <button
              onClick={onCancel}
              className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 py-2.5 px-4 rounded-xl font-medium transition-colors ${
                destructive
                  ? 'bg-red-500 text-white hover:bg-red-600 active:bg-red-700'
                  : 'bg-accent-500 text-white hover:bg-accent-600 active:bg-accent-700'
              }`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
